import { getOfferType } from './offerType';

export const HOME_TITLE = 'Bureaux sans intermédiaire à Paris | Cobuco';
export const HOME_DESCRIPTION =
  'Bureaux à louer ou à acheter à Paris et en Île-de-France. Contactez l’annonceur sans intermédiaire, sans commission Cobuco ni frais cachés de mise en relation.';

export const homepageMetadata = rootURL => ({
  title: HOME_TITLE,
  description: HOME_DESCRIPTION,
  canonicalPath: '/',
  schema: {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${rootURL}/#webpage`,
    url: `${rootURL}/`,
    name: HOME_TITLE,
    description: HOME_DESCRIPTION,
    inLanguage: 'fr-FR',
    isPartOf: { '@id': `${rootURL}#website` },
  },
});

// Only the unfiltered directory and its two offer modes are editorial landing pages.
// User-specific combinations remain navigable without multiplying indexed pages.
export const offerSearchMetadata = search => {
  const params = new URLSearchParams(search);
  [...params.keys()].forEach(key => {
    if (/^utm_/i.test(key) || ['gclid', 'fbclid', 'msclkid'].includes(key)) params.delete(key);
  });
  if (params.get('offerType') === 'all') params.delete('offerType');
  // Pagination currently lives in component state; a page query doesn't change the content.
  params.delete('page');
  const mode = params.get('offerType');
  const isFiltered = [...params.keys()].some(key => key !== 'offerType') ||
    (mode !== null && !['rent', 'sale'].includes(mode)) || params.getAll('offerType').length > 1;
  const title = mode === 'sale'
    ? 'Bureaux à vendre à Paris et en Île-de-France | Cobuco'
    : mode === 'rent'
      ? 'Bureaux à louer à Paris et en Île-de-France | Cobuco'
      : 'Bureaux à louer et à vendre à Paris | Cobuco';
  const description = mode === 'sale'
    ? 'Découvrez les bureaux et espaces professionnels à vendre sur Cobuco. Comparez les biens, les surfaces et les prix, puis contactez les annonceurs.'
    : mode === 'rent'
      ? 'Découvrez les bureaux à louer, coworkings et sous-locations sur Cobuco. Affinez votre recherche par localisation, nombre de postes et budget mensuel.'
      : HOME_DESCRIPTION;
  params.sort();
  return {
    title,
    description,
    canonicalPath: `/annonces${params.toString() ? `?${params}` : ''}`,
    robots: isFiltered ? 'noindex,follow' : 'index,follow',
  };
};

export const listingPageMetadata = (listing, rootURL) => {
  const { title = '', description = '', publicData = {}, state } = listing.attributes || {};
  const mode = getOfferType(publicData);
  const canonicalPath = `/l/${listing.id.uuid}`;
  const cleanDescription = description.replace(/\s+/g, ' ').trim();
  const summary = cleanDescription.length > 160
    ? `${cleanDescription.slice(0, 157).replace(/\s+\S*$/, '')}…`
    : cleanDescription;
  const variants = listing.images?.[0]?.attributes?.variants || {};
  const image = variants.facebook || variants['scaled-large'] || variants['listing-card-2x'];
  const images = image?.url ? [image] : undefined;
  const pageTitle = `${title} — ${mode === 'sale' ? 'À vendre' : 'À louer'} | Cobuco`;
  return {
    title: pageTitle,
    description: summary || `${title}. Découvrez cet espace ${mode === 'sale' ? 'à vendre' : 'à louer'} sur Cobuco et contactez directement l’annonceur.`,
    canonicalPath,
    robots: state === 'published' ? 'index,follow' : 'noindex,nofollow',
    facebookImages: images,
    twitterImages: images,
    schema: [
      {
        '@type': 'WebPage',
        '@id': `${rootURL}${canonicalPath}#webpage`,
        url: `${rootURL}${canonicalPath}`,
        name: pageTitle,
        description: summary,
        inLanguage: 'fr-FR',
        isPartOf: { '@id': `${rootURL}#website` },
        ...(image?.url ? { image: image.url } : {}),
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Accueil', item: `${rootURL}/` },
          { '@type': 'ListItem', position: 2, name: 'Annonces', item: `${rootURL}/annonces` },
          { '@type': 'ListItem', position: 3, name: title, item: `${rootURL}${canonicalPath}` },
        ],
      },
    ],
  };
};
